<template lang="pug">
  v-dialog(:value="value" @input="close" max-width="600")
    v-card
      validation-observer(ref="obs" v-slot="{ handleSubmit }")
        v-form(ref="form")
          v-card-title.headline.mb-4.ml-1 {{ question.question }}
            v-spacer
            v-btn(@click="close" icon)
              v-icon mdi-close
          v-card-text
            p.px-2 {{ question.answer }}
          v-card-actions
            v-spacer
            v-btn(@click="close" color="warning" rounded text) Закрыть
</template>

<script>
export default {
  name: 'ViewQuestionDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    question: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss" scoped>
  p {
    white-space: pre-wrap;
  }

</style>
